import { render, staticRenderFns } from "./GiftcardList.vue?vue&type=template&id=4ab53eea"
import script from "./GiftcardList.vue?vue&type=script&lang=js"
export * from "./GiftcardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports